
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcBrillianceMenu as ObcBrillianceMenuElement} from '@oicl/openbridge-webcomponents/dist/components/brilliance-menu/brilliance-menu.js';
 import {ObcPaletteChangeEvent, ObcBrightnessChangeEvent, ObcLinkPaletteChangeEvent, ObcLinkBrightnessChangeEvent} from '@oicl/openbridge-webcomponents/dist/components/brilliance-menu/brilliance-menu.js';
 export type {ObcPaletteChangeEvent, ObcBrightnessChangeEvent, ObcLinkPaletteChangeEvent, ObcLinkBrightnessChangeEvent} from '@oicl/openbridge-webcomponents/dist/components/brilliance-menu/brilliance-menu.js';
 

 
 export const ObcBrillianceMenu = createComponent({
   react: React,
   tagName: 'obc-brilliance-menu',
   elementClass: ObcBrillianceMenuElement,
   events: {
     
     onPaletteChanged: 'palette-changed' as EventName<ObcPaletteChangeEvent>,
     onBrightnessChanged: 'brightness-changed' as EventName<ObcBrightnessChangeEvent>,
     onLinkPaletteChanged: 'link-palette-changed' as EventName<ObcLinkPaletteChangeEvent>,
     onLinkBrightnessChanged: 'link-brightness-changed' as EventName<ObcLinkBrightnessChangeEvent>,
     onScreenControlLinkClicked: 'screen-control-link-clicked' as EventName<CustomEvent>,
   }
  });
 
 